import { Route, Routes } from "react-router-dom";
import "./index.css";
import "./FontAwesome/css/all.css";
import Navbar from "./Components/Navbar";
import Home from "./Components/Pages/Home";
import FAQ from "./Components/Pages/FAQ";
import Applications from "./Components/Pages/Applications";
import Staff from "./Components/Pages/Staff";
import Error404 from "./Components/Pages/404Page";

function App() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/applications" element={<Applications />} />
        <Route path="/staff" element={<Staff />} />
        <Route path="*" element={<Error404 />} />
      </Routes>
    </>
  );
}

export default App;
